import createApp from "@shopify/app-bridge";
import ShopifyContext from "./context";
import {Toast} from "@shopify/app-bridge/actions";
import CsI18n from "./components/csI18n";
import {getSessionToken} from "@shopify/app-bridge/utilities";

class CsAppBridge {

  static app;
  static apiKey;
  static storeName;
  static host;
  static shop_origin;

  static init() {
    const shopify_context = ShopifyContext.getShared();
    this.apiKey = shopify_context.api_key;
    this.storeName = shopify_context.store;
    this.host = shopify_context.getShopifyHost();
    this.shop_origin = shopify_context.domain;
    console.log('App was loaded with AppBridge');
    return new Promise((resolver, rejection) => {
      if (!this.isValidApp()) {
        rejection('Invalid app!');
      }

      const app = this.getApp();
      const appState = app.getState();
      appState.then(data => {
        const {staffMember} = data;
        resolver(staffMember.locale);
      });
    });
  }

  static isValidApp() {
    return !!(this.apiKey && this.storeName);
  }

  static getAppBridgeConfig() {
    return {
      apiKey: this.apiKey,
      host: this.host,
      shopOrigin: this.shop_origin
    };
  }

  static createApp() {
    this.app = createApp(this.getAppBridgeConfig());
  }

  static getApp() {
    if (!this.app) {
      this.createApp();
    }
    return this.app;
  }

  static _displayToast(message, isError = false) {
    Toast.create(this.getApp(), {
      message: CsI18n.t(message),
      isError: isError || false,
      duration: 5000
    }).dispatch(Toast.Action.SHOW);
  }

  static toastError(error) {
    this._displayToast(error, true);
  }

  static toastSuccess(message) {
    this._displayToast(message, false);
  }

  static getSessionToken = async () => {
    const app = this.getApp();
    return await getSessionToken(app);
  }
}

export default CsAppBridge;